module.exports = __webpack_public_path__ + "static/hot_water_system-8f9ddfc6a34cb58d96843940bdd95c40.jpg";